/* 権限処理 */
window.setPermissionForPage = function(permissions = {}) {
    permissions = typeof permissions === 'object' && permissions !== null ? permissions: {};

    for (const key in permissions) {
        if (permissions.hasOwnProperty(key)) {
            const item = $("[pid='"+key+"']");
            if (item.length == 0) {
                continue;
            }
            if (permissions[key]?.show != 1) {
                item.hide();
            }
            if (permissions[key]?.disable == 1) {
                item.prop('disabled', true);
            }
        }
    }
}